const languages = {
    en: 'English',
    ru: 'Русский',
    fr: 'Français',
    vi: 'Tiếng Việt'
}

export default languages;